import { render, staticRenderFns } from "./NegativeClients.vue?vue&type=template&id=063b919c"
import script from "./NegativeClients.vue?vue&type=script&lang=js"
export * from "./NegativeClients.vue?vue&type=script&lang=js"
import style0 from "./NegativeClients.vue?vue&type=style&index=0&id=063b919c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports